import Abstract from './class.Abstract';

class Tabs extends Abstract {
  constructor() {
    super();

    this.tabHeadings = document.querySelectorAll(`.${super.getHTMLClasses().itemTabHeading}`);

    this.init();
  }

  init() {
    this._showTabContentOnButtonClick();
  }

  _showTabContentOnButtonClick() {
    if (!this.tabHeadings.length) return;

    this.tabHeadings.forEach((tabHeading) => {
      tabHeading.addEventListener('click', (e) => {
        const tab = e.target;

        if (!tab.classList.contains(super.getHTMLClasses().activeItemTabHeading)) {
          this._changeActiveTab(tab);
          this._changeActiveInfo(tab);
        }
      });
    });
  }

  _changeActiveTab(newTab) {
    const parent = newTab.parentElement;

    Abstract.findClassNameAndRemove(super.getHTMLClasses().activeItemTabHeading, parent);
    newTab.classList.add(super.getHTMLClasses().activeItemTabHeading);
  }

  _changeActiveInfo(newTab) {
    const tabTitle = newTab.dataset.tab.trim();
    const infoElement = document.querySelector(`.${super.getHTMLClasses().itemTabInfo}[data-tab="${tabTitle}"]`);
    const parent = infoElement.parentElement;

    Abstract.findClassNameAndRemove(super.getHTMLClasses().activeItemTabInfo, parent);
    infoElement.classList.add(super.getHTMLClasses().activeItemTabInfo);
  }
}

export default Tabs;
